export default {
  COIN_ACTIVITY_REQUEST: 'APP/COIN_ACTIVITY/COIN_ACTIVITY_REQUEST',
  COIN_ACTIVITY_SUCCESS: 'APP/COIN_ACTIVITY/COIN_ACTIVITY_SUCCESS',
  COIN_ACTIVITY_ERROR: 'APP/COIN_ACTIVITY/COIN_ACTIVITY_ERROR',
};
